'use client'

import { type Table } from '@tanstack/react-table'
import { RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import type { EmailTemplateItem } from '@/lib/api/emailTemplates'

interface EmailTemplatesTableActionsProps {
	table: Table<EmailTemplateItem>
	onRefresh: () => void
	isLoading: boolean
}

/**
 * EmailTemplatesTableActions component for table toolbar actions
 */
export function EmailTemplatesTableActions({ table, onRefresh, isLoading }: EmailTemplatesTableActionsProps) {
	const { t } = useTranslation('emails')

	return (
		<div className="flex items-center gap-2">
			<Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
				<RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
				{t('refresh')}
			</Button>
		</div>
	)
}

